import gql from "graphql-tag";


export const EMAIL_WITHOUT_CONTENT_FRAGMENT = gql`
fragment EmailWithoutContentFragment on Email {
  _id
  clientId
  date
  direction
  subject
  to {
    name
    email
  }
  from {
    name
    email
  }
  replyTo {
    name
    email
  }
  error {
    message
    code
    statusCode
  }
  service
  success
}
`

export const CHAT_CLIENT_BASIC_FRAGMENT = gql`
fragment ChatClientBasicFragment on ChatClient {
  id
  createdAt
  customerData {
    name
    email
    phone
    document
    phoneVariations
    occupation
    cep
    registrationChannel
    ownerName
    ownerDocument
    ownerEmail
    salesmanName
    salesmanDocument
    salesmanEmail
    salesmanCollectorName
    salesmanCollectorDocument
    salesmanCollectorEmail
    managerName
    managerDocument
    managerEmail
    serviceData {
      date
      origin
      agency
      agent
      preferredRealEstate
      funnelStepId
      funnelStepPosition
      lastFunnelStepUpdate
    }
    condominium
    unit
    idContrato
    codigoRecibo
    internalId
    civilState
    birthDate
  }
  emailSentDate
  tags {
    text
    type
    reason
    color
    showAtDashboard
    createdAt
  }
  updatedAt
  usersSharedWith {
    id
    name
    nickname
    email
  }
  widgetId
}`

export const CHAT_CLIENT_FUNNEL_STEP_FRAGMENT = gql`
fragment ChatClientFunnelStepFragment on ChatClient {
  id
  updatedAt
  customerData {
    name
    email
    phone
    serviceData {
      funnelStepId
      funnelStepPosition
      lastFunnelStepUpdate
      agent
    }
    internalId
  }
  usersSharedWith {
    email
    name
  }
  tags {
    text
    type
    reason
    color
    showAtDashboard
    createdAt
  }
  widgetId
}`

export const CHAT_CLIENT_MINIMAL_FRAGMENT = gql`
fragment ChatClientMinimalFragment on ChatClient {
  id
  archivedInExternalChannels
  customerData {
    name
    email
    phone
    phoneVariations
    cep
    avatarImageUrl
    serviceData {
      agent
      funnelStepId
      funnelStepPosition
      lastFunnelStepUpdate
      preferredRealEstate
    }
    condominium
    unit
    idContrato
    codigoRecibo
    internalId
  }
  externalChannelsContactData {
    channelType
    idInChannel
  }
  flags {
    informedData
    interacted
    sentToCrm
    isBuy
    isRent
  }
  talkingTo
  talkingToLastActivity
  usersSharedWith {
    id
    name
    nickname
    email
  }
  talkingToHistory {
    talkingTo
    date
    reason
  }
  tags {
    text
    type
    reason
    color
    showAtDashboard
    createdAt
  }
  tagsToAdd {
    text
    type
    reason
    color
    showAtDashboard
    createdAt
    showAtEmail
  }
  tagsToRemove
  updatedAt
  widgetId
  hyperlinks {
    title
    description
    url
  }
  billetData {
    link
    dueDate
    typeableLine
    deleted
    deletedAt
  }
  activities {
    date
    type
    success
    message
  }
}`

export const CHAT_CLIENT_FRAGMENT = gql`
fragment ChatClientFragment on ChatClient {
  id
  activities {
    date
    type
    success
    message
    originUser {
      id
      name
      email
    }
    destinationUsers {
      id
      name
      email
    }
    crmRequestBody
    crmResponse
  }
  createdAt
  deleted
  chats {
    createdAt
    updatedAt
    chatFlowProps {
      context {
        browserInfo {
          currentPageUrl
        }
        realEstateId
        realEstate {
          _id
          _idInAgency
          _idInAgency2
        }
      }
    }
    chatFlowStack {
      currentFlowId
      currentStepId
    }
    state {
      realEstateData {
        roomsMin
        dealType
        usageType
        price
        areaMin
        realEstateType
        cityName
        neighborhood {
          name
        }
      }
      angariationRealEstateData {
        roomsMin
        dealType
        usageType
        price
        areaMin
        realEstateType
        cityName
        neighborhood {
          name
        }
      }
      customerData {
        name
        email
        phone
        document
        cep
        condominium
        unit
        idContrato
        codigoRecibo
        internalId
      }
      humanResourcesData {
        intendedRole
        actualJob
      }
      financingData {
        bornDate
        cpf
        income
        address
        fgts
        maritalStatus
        marriageContractType
        workKind
        admissionDate
        doesRevenueTaxDeclaration
        hasRealEstate
        revenueKind
        bank
        bankAccount
        isFirstRealEstate
        isPublicServer
        isSalesmanAnswering
        salesmanName
        realEstatePrice
      }
      financingQuestionsTofanoData {
        willBuyItYourself
        bornDate
        hasRealEstate
        hasDependents
        hasFgts
        fgtsValue
        income
        bankName
        maxInstallmentValue
        hasDownPayment
        downPaymentValue
      }
      financingQuestionsKeyOnData {
        finality
        city
        neighborhood
        investmentValue
        hasEntry
        entryValue
        doSimulation
        name
        bornDate
        cpf
        civilState
        professionAndCompany
        income
        fgtsValue
        cityAndNeighborhoodLiveIn
        bestDayAndTime
        servicePreference
      }
      financingMinimalData {
        hasEntryValue
        entryValue
        hasFgtsValue
        fgtsValue
        familyIncome
        workKind
      }
      speakWithSalesman {
        text
      }
      visitSchedule {
        date
        realEstates
        text
      }
      searchResults {
        totalResults
        resultsPage {
          realEstateId
          scores {
            price {
              value
            }
            location {
              value
            }
            price {
              value
            }
            extraFeatures {
              value
            }
            area {
              value
            }
            total
          }
          # realEstate {
          #   ...RealEstateFragmentSimple
          # }
        }
      }
      botEvaluation {
        grade
        opinion
        date
      }
      attendantEvaluation {
        grade
        opinion
        date
      }
      rescissionEvaluationData {
        hasPermission
        rescissionProcessOk
        exitInspectionOk
        repairsOk
        finishingOk
        dissatisfactionMessage
      }
    }
    messages {
      origin
      dateSent
      content
      type
      description
    }
  }
  visitedUrls {
    url
    accessCount
    firstAccess
    lastAccess
  }
  customerData {
    name
    email
    phone
    phoneVariations
    document
    avatarImageUrl
    civilState
    birthDate
    occupation
    cep
    registrationChannel
    ownerName
    ownerDocument
    ownerEmail
    salesmanName
    salesmanDocument
    salesmanEmail
    salesmanCollectorName
    salesmanCollectorDocument
    salesmanCollectorEmail
    managerName
    managerDocument
    managerEmail
    registrationUserId
    registrationUser {
      id
      name
      email
    }
    serviceData {
      date
      origin
      preferredChannels
      preferredRealEstate
      agency
      agent
      funnelStepId
      funnelStepPosition
      lastFunnelStepUpdate
    }
    condominium
    unit
    idContrato
    codigoRecibo
    customVars {
      id
      key
      value
    }
    internalId
  }
  emailSentDate
  externalLeadEmails {
    ...EmailWithoutContentFragment
    # html
  }
  externalChannelsContactData {
    channelType
    idInChannel
  }
  fileUploads {
    date
    deleted
    deletedAt
    description
    fileName
    fileNameOrig
    mimetype
    size
    type
  }
  flags {
    interacted
    searched
    informedData
    scheduledVisit
    hasInvalidInput
    sentToCrm
    isBuy
    isRent
  }
  realEstateFeedbacks {
    realEstateId
    reaction
    observations
    timestamp
  }
  observations {
    text
    user {
      id
      name
      email
    }
    timestamp
    deleted
    deletedAt
    clientCanVisualize
    sendingMethod
    linkToSendMessage
  }
  realEstateCharacteristics {
    BUY {
      ids
      prices
      condoPrices
      rooms {
        cont
        name
      }
      totalAreas
      usableAreas
      usageTypes {
        cont
        name
      }
      realEstateTypes {
        cont
        name
      }
      neighborhoods {
        cont
        name
      }
      citys {
        cont
        name
      }
      parking {
        cont
        name
      }
      latitudes
      longitudes
    }
    RENT {
      ids
      prices
      condoPrices
      rooms {
        cont
        name
      }
      totalAreas
      usableAreas
      usageTypes {
        cont
        name
      }
      realEstateTypes {
        cont
        name
      }
      neighborhoods {
        cont
        name
      }
      citys {
        cont
        name
      }
      parking {
        cont
        name
      }
      latitudes
      longitudes
    }
  }
  tags {
    text
    type
    reason
    color
    showAtDashboard
    createdAt
  }
  updatedAt
  usersSharedWith {
    id
    name
    nickname
    email
  }
  whatsappUrl
  widgetId
  entities {
    entityName
    input
    marked
  }
  tagsToAdd {
    type
    text
    reason
    color
    showAtDashboard
    showAtEmail
    createdAt
  }
  tagsToRemove
  hyperlinks {
    title
    description
    url
  }
  billetData {
    link
    dueDate
    typeableLine
    deleted
    deletedAt
  }
}
${EMAIL_WITHOUT_CONTENT_FRAGMENT}
`

export const CHAT_CLIENT_GROUP_FRAGMENT = gql`
fragment ChatClientGroupFragment on ChatClientGroup {
  _id
  # id of the group in the channel (whatsapp, etc...)
  _idInChannel
  archivedInExternalChannels
  avatarImageUrl
  clientIds
  createdAt
  name
  usersSharedWith {
    id
    name
    email
  }
  updatedAt
  widgetId
}`

export const CHAT_CLIENT_GROUP_WITH_CLIENTS_FRAGMENT = gql`
fragment ChatClientGroupWithClientsFragment on ChatClientGroup {
  _id
  # id of the group in the channel (whatsapp, etc...)
  _idInChannel
  archivedInExternalChannels
  avatarImageUrl
  clients {
    ...ChatClientMinimalFragment
  }
  clientIds
  createdAt
  name
  usersSharedWith {
    id
    name
    email
  }
  updatedAt
  widgetId
}
${CHAT_CLIENT_MINIMAL_FRAGMENT}
`
